import React from "react";
import { v4 as uuidv4 } from "uuid";
import { IconButton, Tooltip, Typography } from "@material-ui/core";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: "1.2rem",
    },
    // キーワードコンテナ
    keywordContainer: {
      display: "flex",
    },
    // キーワード展開アイコンコンテナ
    iconContaier: {
      marginRight: theme.spacing(1),
    },
    // キーワード展開アイコンボタン
    iconButtonExpand: {
      position: "relative",
      top: 2,
      width: "1rem",
      height: "1rem",
    },
    // キーワード展開アイコン
    iconExpand: {
      position: "relative",
      top: -8,
    },
    // キーワードエリア（展開）
    keywordAreaExpand: {},
    // キーワードエリア（折り畳み）
    keywordAreaShrink: {
      height: "2.2rem",
      overflowY: "auto",
    },
    // キーワード
    keyword: {
      fontSize: "0.875rem",
      margin: "0.25rem",
      padding: "0.25rem",
      backgroundColor: "yellow",
    },
  })
);

interface Props {
  title?: string;
  keywords?: string[];
}

/** プレビューダイアログタイトル */
export function PreviewDialogTitle(props: Props) {
  const classes = useStyles();

  const { title, keywords } = props;

  // ハイライトキーワード表示
  const [expand, setExpand] = React.useState<boolean>(false);

  // タイトル
  let titleComponent = <></>;
  if (title) {
    titleComponent = (
      <Typography
        component="span"
        color="textPrimary"
        className={classes.title}
      >
        {title}
      </Typography>
    );
  }

  // ハイライトキーワード
  let keywordsComponents = null;
  if (keywords) {
    // 展開時
    keywordsComponents = keywords.map((keyword: string) => {
      return (
        <Typography
          component="span"
          color="textPrimary"
          className={classes.keyword}
          key={uuidv4()}
        >
          {keyword}
        </Typography>
      );
    });
  }

  // 展開アイコンボタン取得
  function getExpandIcon(isExpanded: boolean) {
    // ツールチップ
    const toolTipTitle = isExpanded ? "少なく表示する" : "すべて表示する";

    // 展開,畳込アイコン
    let icon;
    if (isExpanded) {
      icon = <ExpandLess className={classes.iconExpand} fontSize="small" />;
    } else {
      icon = <ExpandMore className={classes.iconExpand} fontSize="small" />;
    }

    return (
      <Tooltip title={toolTipTitle} arrow>
        <IconButton
          className={classes.iconButtonExpand}
          onClick={() => {
            setExpand(!expand);
          }}
        >
          {icon}
        </IconButton>
      </Tooltip>
    );
  }

  //--------------------
  // コンポーネント
  return (
    <>
      <div>{titleComponent}</div>
      {keywordsComponents && (
        <div className={classes.keywordContainer}>
          <div className={classes.iconContaier}>{getExpandIcon(expand)}</div>
          <div
            className={
              expand ? classes.keywordAreaExpand : classes.keywordAreaShrink
            }
          >
            {keywordsComponents}
          </div>
        </div>
      )}
    </>
  );
}
